export const defaultLocale = 'en';

export const SUPPORTED_LOCALES = ['en', 'no', 'fr', 'zh', 'dk'];

const localeToMomentLocalesMap = {
  en: 'en',
  no: 'nb',
  fr: 'fr',
  zh: 'zh',
  dk: 'dk',
};

export const getMomentLocaleFromLocale = locale => localeToMomentLocalesMap[locale];
